import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { fmtPrice } from "../lib/format";
import api from "../lib/api";

export default function Account() {
  const { t } = useLang();
  const { user, loading, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [tab, setTab] = useState("orders");

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [loading, user, navigate]);

  useEffect(() => {
    if (user) api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
  }, [user]);

  if (!user) return <div className="py-40 text-center text-[#8A857D]">…</div>;

  return (
    <div className="max-w-4xl mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="flex items-end justify-between mb-12">
        <div>
          <h1 className="serif text-4xl md:text-5xl">{user.name}</h1>
          <p className="text-[#8A857D] text-sm mt-2">{user.email}</p>
        </div>
        <button onClick={() => { logout(); navigate("/"); }} data-testid="logout-btn" className="text-xs uppercase tracking-[0.2em] text-[#8A857D] hover:text-[#c88] transition-colors">{t("logout")}</button>
      </div>

      {isAdmin && (
        <Link to="/admin" className="inline-block mb-8 border border-[#C49A6C] text-[#C49A6C] text-xs uppercase tracking-[0.2em] px-6 py-3 hover:bg-[#C49A6C] hover:text-[#0B0A08] transition-colors">
          {t("admin")} →
        </Link>
      )}

      <div className="flex gap-8 border-b border-[#262421] mb-10">
        {["orders", "profile"].map((tb) => (
          <button key={tb} onClick={() => setTab(tb)} data-testid={`account-tab-${tb}`} className={`pb-4 text-xs uppercase tracking-[0.2em] transition-colors ${tab === tb ? "text-[#F2EBE1] border-b border-[#C49A6C]" : "text-[#8A857D]"}`}>
            {t(tb)}
          </button>
        ))}
      </div>

      {tab === "orders" && (
        orders.length === 0 ? (
          <p className="text-[#8A857D] py-12">{t("no_orders")}</p>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <Link key={o.id} to={`/order/${o.order_number}`} className="block border border-[#262421] p-6 hover:border-[#C49A6C] transition-colors" data-testid={`account-order-${o.order_number}`}>
                <div className="flex justify-between items-center">
                  <div>
                    <p className="serif text-lg text-[#C49A6C]">{o.order_number}</p>
                    <p className="text-xs text-[#8A857D] mt-1">{new Date(o.created_at).toLocaleDateString()} · {o.items.length} item(s)</p>
                  </div>
                  <div className="text-end">
                    <p className="text-sm">{fmtPrice(o.total, o.currency, t)}</p>
                    <span className="text-[10px] uppercase tracking-widest text-[#c9b978]">{t(`status_${o.status}`)}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )
      )}

      {tab === "profile" && (
        <div className="border border-[#262421] p-8 space-y-4">
          <div className="flex justify-between text-sm"><span className="text-[#8A857D] uppercase tracking-widest text-xs">{t("name")}</span><span>{user.name}</span></div>
          <div className="flex justify-between text-sm"><span className="text-[#8A857D] uppercase tracking-widest text-xs">{t("email")}</span><span>{user.email}</span></div>
        </div>
      )}
    </div>
  );
}
